export default __webpack_public_path__ + "static/media/publish.f49e85d9.svg";